<template>
  <div class="users">
    <!-- <h1>acquirer</h1> -->
    <v-snackbar  v-model="snackbar" :timeout="6000" :color="snackbar_color" location="top" max-height="10cm" max-width="5cm"  multi-line>                  
        {{ snackbar_text }}          
    </v-snackbar>

    <v-row no-gutters>

      <v-col cols="auto" class="me-auto" >
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet class="ma-2 pa-2">
          <!-- <v-breadcrumbs :items="['Users']"></v-breadcrumbs>  -->
          <v-breadcrumbs v-t="'users'"></v-breadcrumbs>
        </v-sheet>        
      </v-col>       
      <v-col cols="auto">
        <v-sheet class="ma-2 pa-2">
          <!-- <v-btn class="text-none text-subtitle-1" color="#5865f2" size="small" variant="flat" >Add Acquirer</v-btn>             -->
          <!-- <v-btn density="compact">Add Acquirer</v-btn>  -->
          <v-btn color="blue" prepend-icon="mdi-plus" @click="compose" v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN', 'ROLE_STAFF_USER')">              
            <template v-slot:prepend >
              <v-icon color="white"></v-icon>
            </template>
            {{ $t('add staff') }}
          </v-btn>      
        </v-sheet>
      </v-col> 
      
    
    </v-row>

    <v-row>
      <v-col cols="4">                                 
        <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('Search')" single-line hide-details></v-text-field>                                              
      </v-col>            
    </v-row>


    <v-card>
      <!-- <v-card-title>
        
        <v-spacer></v-spacer>         
        
      </v-card-title> -->

      <v-data-table
        :headers="headers"
        :items="users"        
        class="elevation-1 custom-table-style"
        :search="search"

        :items-per-page="itemsPerPage" 
        :items-length="totalItems"          
        disable-pagination
        :hide-default-footer="true"
        :fixed-header="true"
        :loading="loading"
        
      >  
        <template v-slot:item.name="{ item }">              
            <td>{{item.raw.firstName +" "+ item.value.lastname}}</td>
        </template>
        <template v-slot:item.status="{ item }">              
            <td>{{item.raw.status}}</td>
        </template> 
        

        <template v-slot:item.actions="{ item }">
            
            <v-tooltip text="Update" location="top">
              <template v-slot:activator="{ props }">                  
                <v-icon v-bind="props" small class="mr-2" color="green" @click="compose_update(item.raw.id)" v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN', 'ROLE_STAFF_USER')">mdi-pencil-circle</v-icon>
              </template>
            </v-tooltip>
            <v-tooltip text="Delete" location="top">
              <template v-slot:activator="{ props }">                  
                <v-icon v-bind="props" small class="mr-2" color="red" @click="compose_delete(item.raw.id)" v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN')">mdi-delete-circle</v-icon>
              </template>
            </v-tooltip>
            
        </template>

        <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
              total-visible="7"            
              @update:model-value="page"              
                                   
            ></v-pagination>
          </div>
        </template>
        

      </v-data-table>
    </v-card>
    


    
  
    <!-- ADD STAFF DIALOG -->
    <v-dialog
            v-model="dialog"
            persistent
            width="1024"
          >
            
            <v-card>
              <v-form v-model="form" @submit.prevent="onSubmit">
              <v-container> 
              <v-card-title>
                <span class="text-h5">{{ $t('add user') }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6" sm="6">                                 
                      <v-text-field :label="$t('First name')" :readonly="loading" :rules="[required]" clearable v-model="user_data.f_firstName" ></v-text-field>                                           
                    </v-col>
                    <v-col cols="6" sm="6">                                 
                      <v-text-field :label="$t('Lastname')" :readonly="loading" :rules="[required]" clearable v-model="user_data.f_lastName" ></v-text-field>                                           
                    </v-col>
                    <v-col cols="12" sm="12">                                 
                      <v-text-field label="username" :readonly="loading" :rules="[required]" clearable v-model="user_data.f_username" ></v-text-field>                                           
                    </v-col>
                    <v-col cols="12" sm="12">                                 
                      <v-text-field type="email" :label="$t('Email')" :readonly="loading" :rules="[required, email]" @change="checkEmail(user_data.f_email)" clearable v-model="user_data.f_email" ></v-text-field>                                           
                    </v-col>                 
                    
                    <v-col cols="12">                                 
                      <v-text-field label="Phone" v-model="user_data.f_phone" ></v-text-field>                                           
                    </v-col>
                    <v-col cols="12" sm="12">                                 
                      <v-select
                        :items= "['true', 'false']"                          
                        :label="$t('Select Status')"                          
                        :rules="[required]"
                        v-model="user_data.f_status"
                      ></v-select>                                              
                    </v-col>                                            
                    
                  </v-row>
                </v-container>
                <small>*indicates required field</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer> 
                <v-btn variant="text"  @click="dialog = false" >{{ $t('Close') }}</v-btn>
                <v-btn :disabled="!form" :loading="loading" color="success" type="submit" variant="text"  @click="addUser" >{{ $t('Save') }}</v-btn> 
              </v-card-actions> 
              </v-container>               
              </v-form>
            </v-card>
          </v-dialog>
          <!-- END ADD USER DIALOG -->

    <!-- UPDATE STAFF DIALOG -->
    <v-dialog
            v-model="dialog_update"
            persistent
            width="1024"
          >              
            <v-card>
              <v-form v-model="form" @submit.prevent="onSubmit">
              <v-container>
              <v-card-title>
                <span class="text-h5">{{ $t('Update User') }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6" sm="6">                                 
                      <v-text-field :label="$t('First name')" :readonly="loading" :rules="[required]" clearable v-model="user_data.f_firstName" ></v-text-field>                                           
                    </v-col>
                    <v-col cols="6" sm="6">                                 
                      <v-text-field :label="$t('Lastname')" :readonly="loading" :rules="[required]" clearable v-model="user_data.f_lastName" ></v-text-field>                                           
                    </v-col>
                    <v-col cols="12" sm="12">                                 
                      <v-text-field label="Username" :readonly="loading" :rules="[required]" clearable v-model="user_data.f_username" ></v-text-field>                                           
                    </v-col>
                    <v-col cols="12" sm="12">                                 
                      <v-text-field :label="$t('Email')" :readonly="loading" :rules="[required, email]" clearable @change="checkEmail(user_data.f_email)" v-model="user_data.f_email" ></v-text-field>                                           
                    </v-col>
                    <v-col cols="12">                                 
                      <v-text-field label="Phone" v-model="user_data.f_phone" ></v-text-field>                                           
                    </v-col>                 
                    <v-col cols="12" sm="12">                                 
                      <v-select
                        :items= "['true', 'false']"                          
                        :label="$t('Select Status')"                      
                        v-model="user_data.f_status"
                      ></v-select>                                              
                    </v-col> 
                   
                    
                  </v-row>
                </v-container>
                <small>*indicates required field</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn variant="text"  @click="dialog_update = false" >{{ $t('Close') }}</v-btn>
                <v-btn :disabled="!form && exist" :loading="loading" color="success" type="submit" variant="text"  @click="updateUser" >{{ $t('Update') }}</v-btn>                  
              </v-card-actions>
              </v-container>               
              </v-form>
            </v-card>
    </v-dialog>
    <!-- END UPDATE ACQUIRER DIALOG -->
          
       
    
    <!-- DELETE STAFF DIALOG -->
    <!-- <v-dialog
            v-model="dialog_delete"
            persistent
            width="500"
          >              
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ $t('do you want to delete') }}?</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                                         
                  </v-row>
                </v-container>
                
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn variant="text"  @click="dialog_delete = false" >{{ $t('Close') }}</v-btn>
                <v-btn color="warning" variant="text"  @click="deleteUser" >{{ $t('Delete') }}</v-btn>                  
              </v-card-actions>
            </v-card>
    </v-dialog> -->

    <v-dialog
              v-model="dialog_delete"
              persistent
              width="400"
            > 
            <v-card>
              <template v-slot:title>
                <span class="font-weight-medium-black">Delete File</span>
              </template>

              <v-card-text class="bg-surface-light py-4">
                Are you sure you want to delete this file?
              </v-card-text>
              <v-card-actions class="mb-2 mr-2">
                  <v-spacer></v-spacer>
                  <v-btn color="red" variant="flat"  @click="deleteUser" >{{ $t('Delete') }}</v-btn>
                  <v-btn variant="flat"  @click="dialog_delete = false" >{{ $t('Close') }}</v-btn>            
                </v-card-actions>
            </v-card>             
             
      </v-dialog>
    <!-- END DELETE STAFF DIALOG -->
    

    


    


  
  
  </div>
</template>

<script>
import axios from 'axios'
//import CryptoJS from 'crypto-js';
export default {
  name: 'Acquirer',
  props: {
    msg: String      
  },    
  data(){
    return {
      name: '',
      emits: ['reload'],
      users: [],          
      roles: [], //in use
      organization: [], //in use
      acquirer: [], //in use        
      dialog: false,   //in use
      dialog_update: false,   //in use
      dialog_delete: false,   //in use
      dialog_password: false,   //in use
      //role_response: [],   //in used
      //second_response: [], //in use
      hashPassword:'',
      
      user_data:{   //in use
        f_firstName: '',
        f_lastName: '',
        f_email: '',
        f_username: '',
        f_phone: '',
        f_status: '',          
        
      },

      

      //form        
      form: false,
      loading: false,
      exist: false,

             
      userId: '', 
      new_url: '',
      
      search: '',
      headers: [
        {
          title: 'Firsname',
          align: 'start',
          sortable: false,
          key: 'firstName',
        },
        { title: 'Lastname', key: 'lastName' },
        { title: this.$t('Email'), key: 'email' },
        { title: 'Phone', key: 'phone' },
        { title: this.$t('Status'), key: 'status'},        
                
        { title: 'Actions', key: 'actions', sortable: false, width:'110px'},
      ],
     

      //FOR USER DATA
      user_roles: '',
      user_org: '',
      user_permissions:[],

      //snackbar
      snackbar: false,
      snackbar_text: '',
      snackbar_color: '',

      existing_email: '',

      //pagination        
      page: 1,
      itemsPerPage: 5,
      totalItems:0,
      totalPages:0,


    }
  },

  created() {     
    
  },

  computed: {
    pageCount () {        
      // console.log("ssss", this.totalItems + " / "+ this.itemsPerPage); 
      let count = Math.ceil(this.totalItems / this.itemsPerPage) 
      // console.log("ssss11 count : ", count);      
      //return Math.ceil(this.totalItems / this.itemsPerPage)
      return count;
    },      
    
  },


  watch:{
      page(newPage){ 
        this.page = newPage         
        this.fetchData()
        // console.log("new page", this.page)          
      },       
      
  },


  methods:{

    onSubmit () {
      if (!this.form) return
      //this.loading = true
      //setTimeout(() => (this.loading = false), 2000)
      //this.addDevice
    },

    required (v) {
      return !!v || 'Field is required'
    },

    min (v) {
      //v => v.length >= 8 || 'Min 8 characters'
      return v.length >= 8 || 'Min 8 characters'
    },

    email(v) {
     
        if (/.+@.+\..+/.test(v)) return true

        return 'E-mail must be valid.'

    },

    /* email_check(v) {                
        this.checkEmail(v)
        if(this.exist) return true
        return 'Email exist'

        //if(this.exist) return 'Email exist'
    },
 */
    // u_email_check(v) {                
    //     this.checkEmail(v)
    //     if(this.exist) return true
    //     return 'Email exist'

    //     //if(this.exist) return 'Email exist'
    // },

    show_toast(status, color, text){
      this.snackbar = status
      this.snackbar_color = color
      this.snackbar_text = text;
    },

    compose() {
        
        this.dialog = true
                
    },

    compose_update(id) {
        this.userId = id
        this.dialog_update = true
        this.requests_handler2()          
    },

    compose_delete(id) {
        this.userId = id
        this.dialog_delete = true                   
    }, 
    
    

    async addUser() {          

        // console.log("user email", this.user_data.f_email)

        //DO NOT DELETE FOR NOW
      //  this.exist = false;

       /*  try {
            let result_email = await axios.get(window.baseurl+"staffs/name/"+this.user_data.f_email , {          
              "headers": {'Authorization': 'Bearer ' + this.accessToken} 
              })
            console.log("RESPONSE", result_email)
            if (result_email.status == 200) {
              //alert("device exist");
              //this.show_toast(true, "warning", "Email exist");                 
              this.$root.vtoast.showError({message: this.user_data.f_email + " Already exist"})
              console.log("EXIST", "email exist")
              this.exist = true;              
              
            }   
        }
        catch (err) {
            console.log("EXIST", "email does not exist")
            console.log(err.response.data);
            this.exist = false;
            
        } */


        if(this.exist){
          // console.log("EXIST112", this.exist);           
          this.$root.vtoast.showError({message: "Email exist"})            
        }
        else{

          // console.log("form data user", this.user_data)
          try{
            
            let result = await axios.post(window.baseurl+"customers", {
                firstName:this.user_data.f_firstName,
                lastName:this.user_data.f_lastName,
                email:this.user_data.f_email,
                username:this.user_data.f_username,
                phone:this.user_data.f_phone,
                status:this.user_data.f_status,                  
                //organization_id:this.orgId,
                createdBy: this.userEmail,
                updatedBy: this.userEmail, 

            },
            {"headers": {'Authorization': 'Bearer ' + this.accessToken} }
            );
            // console.log("result", result);
            if (result.status == 201) {
                //alert("log in successfull");                  
                //this.show_toast(true, "success", "Successful");
                this.$root.vtoast.show({message: result.data.message})
                window.setInterval(() => {
                  this.dialog = false
                  this.$emit("reload")
                }, this.waiting_time)
                           
            }
          }
          catch (error){            
            //this.show_toast(true, "warning", error.message);
            this.$root.vtoast.showError({message: error.message})
          }
        }
    },

    
    requests_handler2() { 
      
      axios.all([
          axios.get(window.baseurl+"staffs/" +this.userId , {          
            "headers": {'Authorization': 'Bearer ' + this.accessToken} 
          }),
          
      ])
      .then(axios.spread((user_response) => {              
            
            // console.log("data1", user_response.data)              

            //get user data for selected id and display data in for dialog
            if(user_response.status == 200){                    
              
              // console.log("acquirer Data", this.acquirer_response)
              this.user_data.f_firstName = user_response.data.firstName
              this.user_data.f_lastName = user_response.data.lastName
              this.user_data.f_email = user_response.data.email
              this.user_data.f_username = user_response.data.username
              this.user_data.f_phone = user_response.data.phone
              this.user_data.f_status = user_response.data.status
              

              this.existing_email = user_response.data.email               
                       
            }

      }))

    }, //end of requests_handler 2 method

    async updateUser() {
        //this.dialog_update = false
        // console.log("update form user id", this.userId)
        // console.log("update form user", this.user_data)

        //DO NOT DELETE FOR NOW
        /* this.exist = false;

        //check if email exist
        if(this.existing_email != this.user_data.f_email){
          try {
              let result_email = await axios.get(window.baseurl+"staffs/name/" + this.user_data.f_email , {          
                "headers": {'Authorization': 'Bearer ' + this.accessToken} 
              })
              console.log("RESPONSE", result_email)
              if (result_email.status == 200) {                  
                this.$root.vtoast.showError({message: this.user_data.f_email +" Already exist"}) 
                console.log("EXIST", "email exist")
                this.exist = true;                
                
              }   
          }
          catch (err) {
              console.log("EXIST", "email does not exist")
              console.log(err.response.data);
              this.exist = false;                
          }
        }
        else{                       
            this.exist = false;
        } */

        //if exist do not submit to database else submit
        if(this.exist){
          //this.show_toast(true, "warning", "Email exist");
          this.$root.vtoast.showError({message: "Email exist"}) 
          // console.log("EXIST112", this.exist);
                   
        }
        else{                       
          
          try{                    
            
            //console.log("SSS11", this.hashPassword)              
            let result = await axios.put(window.baseurl+"staffs/" +this.userId, {
                firstName:this.user_data.f_firstName,
                lastName:this.user_data.f_lastName,
                email:this.user_data.f_email,
                username:this.user_data.f_username,
                phone:this.user_data.f_phone,
                status:this.user_data.f_status,                  
                organization_id:this.orgId,                  
                updatedBy: this.userEmail, 
            },
            {"headers": {'Authorization': 'Bearer ' + this.accessToken}}               
            );

            // console.log("update form user result", result)
            if (result.status == 200) {
                //alert("successfull updated");                  
                //this.show_toast(true, "success", "Successful");
                this.$root.vtoast.show({message: result.data.message})
                window.setInterval(() => {
                  this.dialog_update = false
                  this.$emit("reload")
                }, this.waiting_time)                   
                
            }
          }
          catch (error){            
            //this.show_toast(true, "warning", error.message);
            this.$root.vtoast.showError({message: error.message})
          } 
        } 
    },

    async deleteUser() {
        this.dialog_delete = false
        try{          
          let result = await axios.delete(window.baseurl+"staffs/" +this.userId ,
              {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
              );
          //console.log("update form acquirer result", result)
          if (result.status == 200) {
              //alert("successfull deleted");
              //this.show_toast(true, "success", "Deleted");
              // this.$root.vtoast.show({message: result.data.message})
              this.$root.vtoast.show({message: "Staff Delete"})
              window.setInterval(() => {
                this.$emit("reload")
              }, this.waiting_time)              
          }
        }
        catch (error){            
          //this.show_toast(true, "warning", error.message);
          this.$root.vtoast.showError({message: error.message})
        }
    },

    //CHECK IF EMAIL IN FORM EXSIT
    async checkEmail(email){ 
          
          this.exist = false;
          // console.log("user email", email)

          try {
            let result_email = await axios.get(window.baseurl+"staffs/name/"+email ,
              {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
            );
            // console.log("RESPONSE", result_email)
            if (result_email.status == 200) {
              //alert("device exist");
              //this.show_toast(true, "warning", "Email exist"); 
              this.$root.vtoast.showError({message: email +" Email exist"})
              // console.log("EXIST", "email exist")
              this.exist = true;                
              
            }   
          }
          catch (err) {
            // console.log("EXIST", "email does not exist")
            // console.log(err.response.data);
            this.exist = false;
            
          }
      
    },


    async fetchData() {        

      let result;
      let page2 = this.page - 1;
      try{

        if(this.global_permissions.includes("ROLE_STAFF_ADMIN", 'ROLE_STAFF_USER')){           
          result = await axios.get(window.baseurl+"staffs", {
            params: { page: page2 , pagesize: 100 },
            headers: { 'Authorization': 'Bearer ' + this.accessToken  }            
          }) 
          
          // console.log("user_object", result);
          this.users = result.data.records; 
          this.totalItems = result.data.totalRecords 
          this.itemsPerPage = result.data.pageSize
          this.totalPages = result.data.totalPages
        }
       
        
        
      } 
      catch (error){            
          //this.show_toast(true, "warning", error.message);
          this.$root.vtoast.showError({message: error.message})
      }
    },

    

  },
  
  async mounted(){

    this.checkTokenExpiry();      

    //get user list
    this.fetchData();
    
    

  }
  

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
} */

</style>
